(function () {
  'use strict';
  if (window.gmPooja) return;

  var selector = '[data-gm-pooja-fields]';
  var fieldSelector = '[data-gm-pooja-field]';
  var saved = new Map();
  var fieldOwners = new WeakMap();
  var touched = new WeakSet();
  var calendarWrites = new WeakMap();
  var refreshQueued = false;

  function formOf(group) {
    var id = group.getAttribute('data-gm-pooja-form');
    if (!id || /\s/.test(id)) return null;
    var form = document.getElementById(id);
    return form && form.tagName === 'FORM' ? form : null;
  }

  function stateKey(group) {
    return group.getAttribute('data-gm-pooja-form') + ':' + group.getAttribute('data-product-id');
  }

  function birthDate(value, group) {
      var parts = value.match(/^(\d{2})([-\/])(\d{2})\2(\d{4})$/);
      if (!parts) return { error: group.getAttribute('data-dob-format-error') };
      var day = Number(parts[1]);
      var month = Number(parts[3]);
      var year = Number(parts[4]);
      var date = new Date(0);
      date.setHours(0, 0, 0, 0);
      date.setFullYear(year, month - 1, day);
      if (year < 1 || month < 1 || month > 12 || day < 1 || day > 31 || date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return { error: group.getAttribute('data-dob-invalid-error') };
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (date.getTime() > today.getTime()) return { error: group.getAttribute('data-dob-future-error') };
      return { date: date };
  }

  function messageFor(field, group) {
    var value = String(field.value || '').trim();
    if (field.disabled) return '';
    if (!value) return field.required ? group.getAttribute('data-required-error') : '';
    var kind = field.getAttribute('data-gm-pooja-field');
    if (kind === 'dob') return birthDate(value, group).error || '';
    if (kind === 'time' && !/^(0?[1-9]|1[0-2]):[0-5][0-9] ?(AM|PM)$/i.test(value)) return group.getAttribute('data-time-format-error');
    return '';
  }

  function updateField(field, group, report) {
    field.setCustomValidity(messageFor(field, group) || '');
    var invalid = !field.disabled && field.willValidate && !field.validity.valid;
    var show = invalid && (report || touched.has(field));
    if (show) field.setAttribute('aria-invalid', 'true');
    else field.removeAttribute('aria-invalid');
    var error = field.parentElement && field.parentElement.querySelector('[data-gm-pooja-error]');
    if (error) {
      var text = show ? field.validationMessage : '';
      if (error.textContent !== text) error.textContent = text;
      error.hidden = !show;
    }
    return !invalid;
  }

  function remember(field) {
    var owner = fieldOwners.get(field);
    if (!owner) return;
    var values = saved.get(owner.key);
    if (!values) saved.set(owner.key, values = new Map());
    values.set(owner.name, String(field.value || ''));
  }

  function calendar(field, group) {
    if (field.getAttribute('data-gm-pooja-field') !== 'dob' || field.datepicker || typeof window.Datepicker !== 'function' || messageFor(field, group) && field.value.trim()) return;
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    try {
      new window.Datepicker(field, {
        format: {
          toValue: function (value) { return birthDate(String(value || '').trim(), group).date || NaN; },
          toDisplay: function (date) { return String(date.getDate()).padStart(2, '0') + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getFullYear()).padStart(4, '0'); }
        },
        maxDate: today
      });
      var picker = field.datepicker.pickerElement;
      function completeCalendarClick(event) {
        if (calendarWrites.get(field) !== event) return;
        calendarWrites.delete(field);
        if (!field.isConnected || field.form !== formOf(group)) return;
        touched.add(field);
        updateField(field, group, false);
        remember(field);
      }
      picker.addEventListener('click', function (event) {
        var cell = event.target.closest && event.target.closest('.datepicker-cell[data-date]');
        if (!cell || cell.classList.contains('disabled')) return;
        calendarWrites.set(field, event);
        setTimeout(function () {
          if (calendarWrites.get(field) !== event) return;
          var selected = birthDate(String(field.value || '').trim(), group).date;
          if (selected && selected.getTime() === Number(cell.getAttribute('data-date'))) completeCalendarClick(event);
          else calendarWrites.delete(field);
        }, 0);
      }, true);
      picker.addEventListener('click', completeCalendarClick);
    } catch (error) {}
  }

  function bind(group) {
    var form = formOf(group);
    if (!form) return [];
    var key = stateKey(group);
    var values = saved.get(key);
    var fields = Array.from(group.querySelectorAll(fieldSelector)).filter(function (field) { return field.form === form; });
    fields.forEach(function (field) {
      if (!fieldOwners.has(field)) {
        fieldOwners.set(field, { key: key, name: field.name });
        if (!field.value && values && values.has(field.name)) field.value = values.get(field.name);
      }
      calendar(field, group);
      updateField(field, group, false);
      remember(field);
    });
    return fields;
  }

  function groups() {
    return Array.from(document.querySelectorAll(selector));
  }

  function refresh() {
    groups().forEach(bind);
  }

  function validate(form, options) {
    if (!form || form.tagName !== 'FORM') return true;
    var report = !!(options && options.report);
    var firstInvalid = null;
    groups().filter(function (group) { return formOf(group) === form; }).forEach(function (group) {
      bind(group).forEach(function (field) {
        if (!updateField(field, group, report) && !firstInvalid) firstInvalid = field;
      });
    });
    if (firstInvalid && report) {
      try { firstInvalid.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (error) {}
      try { firstInvalid.focus({ preventScroll: true }); } catch (error) { firstInvalid.focus(); }
      firstInvalid.reportValidity();
    }
    return !firstInvalid;
  }

  function fieldChanged(event) {
    var field = event.target;
    if (!field || !field.matches || !field.matches(fieldSelector)) return;
    var group = field.closest(selector);
    if (!group || !formOf(group) || field.form !== formOf(group)) return;
    bind(group);
    touched.add(field);
    updateField(field, group, false);
    remember(field);
  }

  function associatedForm(button) {
    if (button.form) return button.form;
    var id = button.getAttribute('form') || button.getAttribute('data-form-id');
    var form = id && document.getElementById(id);
    return form || button.closest('form');
  }

  function guard(event, form) {
    if (validate(form, { report: true })) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  ['input', 'change', 'changeDate'].forEach(function (name) { document.addEventListener(name, fieldChanged, true); });
  document.addEventListener('hide', function (event) {
    var field = event.target;
    var group = field && field.closest && field.closest(selector);
    var owner = fieldOwners.get(field);
    var values = owner && saved.get(owner.key);
    var previous = values && values.get(owner.name);
    if (!group || !field.datepicker || calendarWrites.has(field) || !previous || !birthDate(previous.trim(), group).error) return;
    field.value = previous;
    updateField(field, group, false);
  }, true);
  document.addEventListener('focusin', function (event) {
    var field = event.target;
    var group = field && field.closest && field.closest(selector);
    if (group && field.matches(fieldSelector) && field.form === formOf(group)) calendar(field, group);
  }, true);
  document.addEventListener('invalid', function (event) {
    var field = event.target;
    var group = field && field.closest && field.closest(selector);
    if (group && field.matches(fieldSelector) && field.form === formOf(group)) {
      touched.add(field);
      updateField(field, group, true);
    }
  }, true);
  document.addEventListener('submit', function (event) { guard(event, event.target); }, true);
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[data-custom-main-atc], button[name="add"], button[name="checkout"], button[type="submit"], input[type="submit"]');
    if (button) guard(event, associatedForm(button));
  }, true);
  document.addEventListener('product:rerender', function () {
    groups().forEach(function (group) { bind(group).forEach(remember); });
  }, true);

  function removedFields(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(fieldSelector)) remember(node);
    node.querySelectorAll(fieldSelector).forEach(remember);
  }

  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    queueMicrotask(function () { refreshQueued = false; refresh(); });
  }

  window.gmPooja = Object.freeze({ validate: validate, refresh: refresh });
  new MutationObserver(function (records) {
    var relevant = false;
    records.forEach(function (record) {
      record.removedNodes.forEach(removedFields);
      if (record.target.closest && record.target.closest(selector)) relevant = true;
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))) relevant = true;
      });
    });
    if (relevant) queueRefresh();
  }).observe(document.documentElement, { childList: true, subtree: true });
  refresh();
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', refresh, { once: true });
})();
